// extracted by mini-css-extract-plugin
export default {"TagContainer":"_TagContainer--fT80M","TagColumn":"_TagColumn--Ooz0v","PaginationContainer":"_PaginationContainer--kyC5b"};